function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#FC4E1F",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M15.932 11.478a3.695 3.695 0 0 0-.831-.41c-.992-.347-1.253-.26-1.774.67-.384.682-.72 1.377-1.104 2.059-.161.298-.347.595-.595.83-1.29 1.278-2.915 1.502-4.639 1.39.521-.298.868-.744 1.166-1.253a54.03 54.03 0 0 0 1.129-2.046c.397-.757.955-1.34 1.736-1.7.137-.061.26-.111.397-.16-.012-.013-.012-.025-.025-.038h-.111c-1.873.273-3.634.844-5.222 1.898-.695.446-1.302.992-1.737 1.711-.607 1.018-.334 2.047.72 2.58.36.186.756.323 1.14.422 1.254.298 2.519.223 3.771 0 1.737-.31 3.387-.893 4.85-1.898.695-.471 1.327-1.03 1.712-1.81.434-.856.223-1.7-.583-2.245z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M19.48 7.05c-2.618 0-5.247-.013-7.864.012-.732 0-1.476.062-2.208.174-1.179.173-2.282.595-3.188 1.401-.459.397-.818.88-1.042 1.489.137.012.224.024.323.024 2.84 0 5.693.013 8.533-.012 1.302-.012 2.58-.248 3.746-.856.942-.484 1.65-1.178 2.108-2.232h-.409z",
  opacity: 0.7
}));

var SvgIcTbank = function SvgIcTbank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTbank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_tbank.ecd1eef8.svg";
export { ForwardRef as ReactComponent };